module.exports = __webpack_public_path__ + "assets/ic_character5.279a4e2b.svg";